import React from 'react';

import ThemeProvider from '@material-ui/styles/ThemeProvider';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

const theme = createMuiTheme({
    typography: {
        fontFamily: 'Arial, Helvetica, sans-serif'  // Same font-family that's used on the website
    }
});

export default class Theme extends React.Component{
    render(){
        return(
            <ThemeProvider theme={theme}>
                { this.props.children }
            </ThemeProvider>
        )
    }
}